export default "__VITE_ASSET__fuXGVxnD__"